const GlobalNav = () => {
  const body = document.body;
  const elBtnMenu = document.getElementById('js-global-mobile-menu-btn');
  const elFlyOutContainer = document.getElementById(
    'js-global-nav-flyout-container',
  );

  const elFlyOutDiscover = document.getElementById('js-nav-discover');
  // Utility function to toggle menu open state
  const toggleHamburgerMenu = () => {
    body.classList.toggle('menu-open');
    elFlyOutContainer?.classList.toggle('active');
  };

  // Function to handle the mobile menu button click
  const setupMobileMenuButton = () => {
    if (elBtnMenu) {
      elBtnMenu.addEventListener('click', toggleHamburgerMenu);
    }
  };

  // Function to handle desktop menu item clicks
  const handleDesktopMenuItemClick: EventListener = event => {
    if (event instanceof MouseEvent || event instanceof TouchEvent) {
      const button = event.target as HTMLElement;
      const target = button.dataset.target;
      if (button.classList.contains('active')) {
        elFlyOutContainer?.classList.remove('active');
        button.classList.remove('active');
        return;
      }

      const elNavBtns = document.querySelectorAll('.js-main-menu-btn.active');
      elNavBtns.forEach(elNavBtn => {
        elNavBtn.classList.remove('active');
      });

      button.classList.add('active');

      const xPosition =
        button.getBoundingClientRect().left + window.scrollX + 20;

      elFlyOutContainer?.classList.add('active');

      switch (target) {
        case 'discover':
          if (elFlyOutDiscover) {
            elFlyOutDiscover.classList.add('active');
            elFlyOutDiscover.style.paddingLeft = xPosition + 'px';
          }
          break;
      }
    }
  };

  // Function to setup event listeners for desktop menu items
  const setupDesktopMenu = () => {
    const elNavBtns = document.querySelectorAll('.js-main-menu-btn');
    elNavBtns.forEach(elNavBtn => {
      elNavBtn.addEventListener('click', handleDesktopMenuItemClick);
      elNavBtn.addEventListener('touchstart', handleDesktopMenuItemClick, {
        passive: true,
      });
    });
  };

  const handleMobileExpandMenuItemClick: EventListener = event => {
    if (event instanceof MouseEvent || event instanceof TouchEvent) {
      let button = event.currentTarget as HTMLElement; // Use currentTarget to get the element to which the event handler is attached

      // If currentTarget isn't a button, traverse up to find the button
      while (button && button.tagName !== 'BUTTON') {
        button = button.parentElement as HTMLElement;
      }

      // Check if the button was found
      if (button && button.tagName === 'BUTTON') {
        const target = button.dataset.target;

        switch (target) {
          case 'discover':
            if (elFlyOutDiscover) {
              elFlyOutDiscover.classList.toggle('active');
            }
            break;
          default:
            console.log('Unknown target:', target);
            break;
        }
      } else {
        console.log('No button found for the event target');
      }
    }
  };

  const setupMobileExpandItems = () => {
    const elNavBtns = document.querySelectorAll('.js-expand-panel-btn');
    elNavBtns.forEach(elNavBtn => {
      elNavBtn.addEventListener('click', handleMobileExpandMenuItemClick);
    });
  };

  // Initialize the global navigation
  const initGlobalNav = () => {
    setupMobileMenuButton();
    setupDesktopMenu();
    setupMobileExpandItems();
  };

  return {
    initGlobalNav,
  };
};

export default GlobalNav;
